import { Component } from '@angular/core';
import { soundpostReportOutputARAgingEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Report Output AR Agings') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostreportoutputaraging-form',
    templateUrl: './soundpostreportoutputaraging.form.component.html'
})
export class soundpostReportOutputARAgingFormComponent extends BaseFormComponent {
    public record!: soundpostReportOutputARAgingEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

